<script>
	import { isFirstOrbClaimed, orbToOpenInModal, userMysteryOrbs } from '$lib/tradingSeason/store';
	import { smartContractWalletAddress } from '$lib/home/scwallet/store';
	import { claimOrb } from '$lib/data/rewards';
	import { popupModalOpen } from '$lib/popups/popupsStore';
	import {
		orbTypeToNameMap,
		orbContentTypeToNameMap,
		orbTweetContent
	} from '$lib/tradingSeason/constants';
	import { fly } from 'svelte/transition';
	import { quadOut } from 'svelte/easing';

	$: showRewards = false;
	$: isClaiming = false;
	$: orb = $userMysteryOrbs?.find((o) => o.id === $orbToOpenInModal);

	const handleClaimOrb = async () => {
		try {
			if (isClaiming) return;
			if (!$orbToOpenInModal) return;

			isClaiming = true;
			await claimOrb($orbToOpenInModal, $smartContractWalletAddress);
			isClaiming = false;
			showRewards = true;
		} catch (err) {
			isClaiming = false;
		}
	};

	const handleCloseModal = () => {
		popupModalOpen.set(false);
	};

	const handleTweetClick = () => {
		// TODO, confirm the content to tweet
		window.open(`https://twitter.com/share?${orbTweetContent}`, '_blank');
	};
</script>

{#if orb && !showRewards}
	<div
		out:fly={{
			duration: 200,
			x: 0,
			y: -50,
			opacity: 0.1,
			easing: quadOut,
			delay: 0
		}}
		class="flex flex-col items-center gap-6 justify-center w-[306px] rounded-[20px] border-[1px] border-solid border-fx-grey-500 bg-fx-gradient-8 overflow-hidden relative"
	>
		<img
			src={`trading-season/MysteryOrbsSection/orbs/${orb.type.toLowerCase()}-orb.webp`}
			alt="Orb"
			loading="lazy"
			class="w-full h-[240px] object-cover rounded-none"
		/>
		<div class="flex flex-col items-center justify-center gap-2">
			<p class="text-gradients-accent-shade-6 text-2xl leading-[30px] font-semibold">
				{$isFirstOrbClaimed ? orbTypeToNameMap[orb.type] : 'First Mystery Orb'}
			</p>
			<p class="text-sm text-fx-grey-300 text-center max-w-[85%]">
				{$isFirstOrbClaimed
					? 'Find out what you’ve won.'
					: 'You will receive orbs like this one on your trading journey with Polynomial. Reveal your orbs to win rewards.'}
			</p>
		</div>
		<div class="h-[1px] bg-fx-grey-600 w-full" />
		<button
			class="w-[85%] mb-5 bg-fx-gradient-5 rounded-xl flex justify-center items-center py-[18px]"
			on:click={handleClaimOrb}
		>
			<p class="text-base font-semibold text-fx-black">Reveal Mystery Orb</p>
		</button>
	</div>
{/if}
{#if showRewards}
	<div
		in:fly={{
			duration: 200,
			x: 0,
			y: 100,
			opacity: 0.1,
			easing: quadOut,
			delay: 200
		}}
		class="flex flex-col items-center gap-6 justify-center w-[306px] rounded-[20px] border-[1px] border-solid border-fx-grey-500 bg-fx-gradient-8 overflow-hidden relative"
	>
		<div class="bg-fx-gradient-orb-modal w-full h-full">
			<img
				src={`trading-season/orb-celebration.webp`}
				alt="Orb"
				loading="lazy"
				class="w-full h-[240px]"
			/>
		</div>
		{#if orb?.contents}
			<div class="flex flex-col items-center justify-center gap-2">
				{#each orb?.contents as content}
					<div class="flex items-center justify-center gap-1">
						<img src="trading-season/points.webp" alt="Points" class="w-7 h-7 -mt-1" />
						<p class="text-2xl leading-[30px] font-semibold text-points">
							{content.data}
							{orbContentTypeToNameMap[content.type]}
						</p>
					</div>
				{/each}
				<p class="text-sm text-fx-gradient-5 text-center">
					Congrats! Keep collecting points to win big rewards in future.
				</p>
			</div>
		{/if}
		<div class="h-[1px] bg-fx-grey-600 w-full" />
		<div class="flex justify-center items-center w-full gap-2.5 mb-5 px-5">
			<button
				class="w-full bg-fx-gradient-5 rounded-xl flex justify-center items-center py-[18px]"
				on:click={handleCloseModal}
			>
				<p class="text-base font-semibold text-fx-black">Go Back</p>
			</button>
			<button
				class="w-full bg-fx-black border border-fx-grey-400 rounded-xl flex justify-center items-center gap-0.5 py-[18px]"
				on:click={handleTweetClick}
			>
				<p class="text-base font-semibold text-fx-white">🎉 Share on</p>
				<img src="trading-season/x.webp" alt="X" class="w-5 h-5 -mt-0.5" />
			</button>
		</div>
	</div>
{/if}

<style>
	.text-points {
		background: linear-gradient(180deg, #ffb13d 15.79%, #d24e12 100%);
		background-clip: text;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
</style>
